export enum NotificationModuleType {
  None = 'None',
  WorkItem = 'WorkItem',
  Client = 'Client',
  ClientConfig = 'ClientConfig',
  Process = 'Process',
  Activity = 'Activity',
  Task = 'Task',
  Integration = 'Integration'
}
